var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-app',{attrs:{"force-no-auth":""}},[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('reset-password',{staticClass:"mx-auto",attrs:{"email":_vm.email}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }